import { render, staticRenderFns } from "./legal-settings.vue?vue&type=template&id=5602110c&"
import script from "./legal-settings.vue?vue&type=script&lang=ts&"
export * from "./legal-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports